import {
  objectResolver,
  resolveBoolean,
  resolveNumber,
  resolveString,
} from 'airship/utils/resolvers'
import {Resolver} from 'airship/utils/resolvers/types'

export interface CreateTicketResponse {
  ticketNumber: number
  supportLevel: string
  imageError?: boolean
  isDGCP: boolean
}

export const resolveCreateTicketResponse: Resolver<CreateTicketResponse> = objectResolver(
  {
    ticketNumber: resolveNumber,
    supportLevel: resolveString,
    imageError: resolveBoolean,
    isDGCP: resolveBoolean,
  }
)
